import { memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Marker } from "react-mapbox-gl";

import { LOCATIONS_PLAN_TYPE } from "../../../consts/planTypes";

import { selectedRouteSelector } from "../../../reducers/ownApp/selectors";
import {
  getMatrixProfileType,
  heatmapViewSelector,
  multiPostcodesSelector,
} from "../../../reducers/matrixProfile/selectors";
import {
  artificialFeaturesSelector,
  streetViewSelector,
  zoomLevelSelector,
} from "../../../reducers/map/selectors";
import { postcodeClickHandler } from "../../../reducers/ownApp/thunkActions";
import { setZoomFromMouseEvent } from "../../../reducers/map/thunkActions";
import { visibleArtificialTablesSelector } from "../../../reducers/depot/selectors";
import { setPopupDetails } from "../../../reducers/map";

import { useLocationDetails } from "../../../hooks/useLocationDetails";

import { Postcode } from "../../../utils/postcode";

import { ArtificialPostcodesTile } from "./ArtificialPostcodesTile";

const useStyles = makeStyles({
  marker: {
    marginTop: "2px",
    padding: "4px",
    height: "24px",
    border: "1px solid black",
    cursor: "grab",
  },
});

export const ArtificialPostcodesLayer = memo(() => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { application } = useLocationDetails();
  const visibleArtificialTables = useSelector(visibleArtificialTablesSelector);
  const artificialFeatures = useSelector(artificialFeaturesSelector);
  const multiPostcodeFeatures = useSelector(multiPostcodesSelector);
  const zoomLevel = useSelector(zoomLevelSelector);
  const heatmapView = useSelector(heatmapViewSelector);
  const streetView = useSelector(streetViewSelector);
  const selectedRoute = useSelector(selectedRouteSelector);
  const planType = useSelector(getMatrixProfileType);

  return (
    <>
      {Object.values(visibleArtificialTables?.[zoomLevel] || {}).map(
        ({ postcode, lat, lng }) => (
          <Marker
            key={`${postcode}-${lat}-${lng}`}
            coordinates={{ lat, lng }}
            anchor={"center"}
            className={styles.marker}
            onClick={() =>
              dispatch(
                postcodeClickHandler({
                  postcode,
                  level: zoomLevel,
                  application,
                })
              )
            }
            onWheel={(e) => dispatch(setZoomFromMouseEvent(e))}
            onMouseEnter={() =>
              artificialFeatures[postcode] &&
              dispatch(
                setPopupDetails({
                  coordinates: [lng, lat],
                  routes: [artificialFeatures[postcode].routeCode],
                  postcode,
                  level: Postcode.getLevel(postcode),
                })
              )
            }
          >
            <ArtificialPostcodesTile
              postcode={postcode}
              selectedRoute={selectedRoute}
              zoomLevel={zoomLevel}
              streetView={streetView || planType === LOCATIONS_PLAN_TYPE}
              heatmapView={heatmapView}
              artificialFeatures={artificialFeatures}
              multiPostcodeFeatures={multiPostcodeFeatures}
            />
          </Marker>
        )
      )}
    </>
  );
});
